import { I18nKeys, PreTFunctionArgs } from '@predium/i18n/client';
import { initializedI18n } from '../../../i18n';

const originalT = initializedI18n.t;

export const t = <Key extends I18nKeys>(...args: PreTFunctionArgs<Key>) => {
  let key = args[0];
  const options = args[1];
  const orgSector = (options ?? {})?.orgSector;

  if (orgSector) {
    key = `${key}_${orgSector}` as Key;
  }

  return originalT(key, options);
};
